export default __webpack_public_path__ + "assets/logo.a3b67d.svg";